import { IndicatorData } from '../TechnicalAnalysisTradingView';


export interface OhlcRow {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export function calculateStochastic(data: OhlcRow[], kPeriod: number = 14, dPeriod: number = 3): { k: IndicatorData[], d: IndicatorData[] } {
  const kValues: IndicatorData[] = [];
  const dValues: IndicatorData[] = [];
  
  if (!data || data.length < kPeriod || kPeriod <= 0 || dPeriod <= 0) {
    return { k: kValues, d: dValues };
  }
  
  // Calculate %K values without array allocation or spread operator
  for (let i = kPeriod - 1; i < data.length; i++) {
    const startIdx = i - kPeriod + 1;
    let highestHigh = data[startIdx]?.high ?? 0;
    let lowestLow = data[startIdx]?.low ?? 0;

    for (let j = startIdx + 1; j <= i; j++) {
      const h = data[j]?.high ?? 0;
      const l = data[j]?.low ?? 0;
      if (h > highestHigh) highestHigh = h;
      if (l < lowestLow) lowestLow = l;
    }

    const currentClose = data[i]?.close ?? 0;
    const diff = highestHigh - lowestLow;
    const kPercent = diff === 0 ? 50 : ((currentClose - lowestLow) / diff) * 100;

    kValues.push({
      time: data[i]?.time ?? 0,
      value: kPercent
    });
  }
  
  // Calculate %D values (SMA of %K) using sliding window sum
  if (kValues.length >= dPeriod) {
    let dSum = 0;
    for (let i = 0; i < dPeriod; i++) {
      dSum += kValues[i]?.value ?? 0;
    }
    dValues.push({
      time: kValues[dPeriod - 1]?.time ?? 0,
      value: dSum / dPeriod
    });

    for (let i = dPeriod; i < kValues.length; i++) {
      dSum += (kValues[i]?.value ?? 0) - (kValues[i - dPeriod]?.value ?? 0);
      dValues.push({
        time: kValues[i]?.time ?? 0,
        value: dSum / dPeriod
      });
    }
  }
  
  return { k: kValues, d: dValues };
}
